import { render } from "./projectsWrappers.vue?vue&type=template&id=cf60f9f4&scoped=true"
import script from "./projectsWrappers.vue?vue&type=script&lang=js"
export * from "./projectsWrappers.vue?vue&type=script&lang=js"

import "./projectsWrappers.vue?vue&type=style&index=0&id=cf60f9f4&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf60f9f4"]])

export default __exports__